import { useEffect, useRef } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { usePortal } from "../../context/PortalsContext";
import { useAuth } from "../../context/AuthContext";
import { clearAuthSessionStorage } from "../../utils/authUtils";

export const GuestRoute: React.FC = () => {
  const { auth, dispatch } = useAuth();
  const { dispatch: portalsDispatch } = usePortal();
  const location = useLocation();
  const { user, loadStatus } = auth;
  const isPasswordResetRoute = location.pathname === "/new-password";
  const hadUserOnEntryRef = useRef<boolean>(false);

  useEffect(() => {
    // Only treat /new-password as "force logout" if the user was already logged in
    // when they entered the route. This prevents the invite/new-password flow from
    // immediately clearing the user after successful authentication.
    if (loadStatus === "loaded") {
      hadUserOnEntryRef.current = Boolean(user);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadStatus]);

  useEffect(() => {
    if (isPasswordResetRoute && user && hadUserOnEntryRef.current) {
      clearAuthSessionStorage();
      dispatch({ type: "CLEAR_USER" });
      portalsDispatch({ type: "SET_PORTALS", payload: [] });
      portalsDispatch({ type: "CLEAR_SELECTED_PORTAL" });
    }
  }, [dispatch, isPasswordResetRoute, portalsDispatch, user]);

  if (loadStatus !== "loaded") {
    return null;
  }

  if (isPasswordResetRoute) {
    return <Outlet />;
  }

  if (user) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
};
